module.exports = {"apiUrl":"https://api.jlaasociados.net","webUrl":"http://www.jlaasociados.es"};